import React from 'react';
import { Modal as AntdModal } from 'antd';
import type { ButtonProps } from 'antd';
import { ModalProps as AntdModalProps } from 'antd/lib/modal';
import classNames from 'classnames';
import './modal.scss';
const { confirm, info, warning, error, success } = AntdModal;

export interface ModalProps extends Omit<AntdModalProps, 'visible'> {
	className?: string;
	cancelButtonProps?: ButtonProps;
	okButtonProps?: ButtonProps;
	visible?: boolean;
}

const Modal: React.FC<ModalProps> = ({
	className,
	okButtonProps,
	cancelButtonProps,
	visible,
	...otherProps
}: ModalProps) => {
	return (
		<AntdModal
			className={classNames('bringg-modal', className)}
			okButtonProps={{
				...okButtonProps,
				className: classNames('ant-btn-primary', 'bringg-btn', okButtonProps?.className)
			}}
			cancelButtonProps={{
				...cancelButtonProps,
				className: classNames('bringg-btn', 'ant-btn-link', cancelButtonProps?.className)
			}}
			open={visible}
			{...otherProps}
		/>
	);
};

export default Modal;
export { confirm, info, warning, error, success };
